<template>
	<div class="flex items-center justify-center" :class="{ 'py-16': block }" role="status" :aria-label="label">
		<span class="block animate-spin rounded-full border-[3px] border-line border-t-accent" :style="{ width: `${size}px`, height: `${size}px` }" />
	</div>
</template>

<script>
// Also registered globally as <Spinner>, which the reused website payment buttons expect.
export default {
	props: {
		size: { type: Number, default: 28 },
		block: { type: Boolean, default: false },
		label: { type: String, default: 'Loading' },
	},
}
</script>
